import { useState } from "react";
import { useTranslation } from "react-i18next";
import Close from "../../../assets/images/icons/close.svg";

const ReportParkingViolationModal = ({
    zoneId,
    onClose,
    bookingDateStr,
    spotId,
    spotName,
    isLoading,
    onSubmit,
}) => {
    const { t } = useTranslation();
    const [plateNo, setPlateNo] = useState("");

    return (
        <div id="divReportParkingViolationModal">
            <div
                className="modal"
                style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}
                id="dateModal"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
            >
                <div className="modal-dialog modal-dialog-centered modal-custom-width">
                    <div className="modal-content modal-radius">
                        <div className="modal-body">
                            <div className="close-modal">
                                <a onClick={(e) => {
                                    e.preventDefault();
                                    onClose();
                                }}>
                                    <img src={Close} aria-label="Close" />
                                </a>
                            </div>

                            <div className="pt-4 text-center px-4">
                                <h5 className="popup-title text-red">
                                    {t("react_is_someone_already_parked")} <span>{spotName}?</span>
                                </h5>
                            </div>

                            <div className="divider-line mt-3"></div>
                            <div className="text-center">
                                <p>{t("react_enter_license_plate_number")}</p>
                            </div>
                            <div className="modal-details">
                                <div className="form-row">
                                    <label className="popup-inner-title m-0">{t("license_plate_number")}</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        autoComplete="off"
                                        value={plateNo}
                                        onChange={(e) => setPlateNo(e.target.value)}
                                    />
                                </div>
                                <p>{t("react_parking_violation_notification")}</p>
                            </div>
                            <div className="mt-3 pt-3">
                                <button
                                    className="main-btn fill-red-btn w-100"
                                    onClick={async (e) => {
                                        e.preventDefault();
                                        onClose();
                                        if (!isLoading) {
                                            await onSubmit(zoneId, plateNo, spotId, spotName, 2, bookingDateStr);
                                        }
                                    }}
                                >
                                    {t("react_send_to_parking_management")}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReportParkingViolationModal;
